export default {
	REPORTING_REASONS: [
		'Rude/offensive content',
		'Copyrighted work',
		'Impersonation',
		'Advertising/spam',
		'Other'
	],
	SPECIALTIES: [
		'Advertising',
		'Architecture',
		'Birding',
		'Celebrities',
		'Cinema',
		'Commercial',
		'Corporate',
		'Documentary',
		'Editorial',
		'Education',
		'Events',
		'Fashion',
		'Fine Art',
		'Food',
		'Landscape',
		'Music',
		'Portrait',
		'Sports',
		'Travel',
		'TV/Broadcast/Web TV',
		'Underwater',
		'Vlogging',
		'Wedding',
		'Wildlife',
		'Other',
	],
	SPECIALTIES_DICTIONARY: {
		'Advertising/Product/Stock': 'Advertising',
		'Architecture/Industrial/Real Estate': 'Architecture',
		'Cinema/Motion Picture': 'Cinema',
		'Law Enforcement/Legal': 'Corporate',
		'Medical/Scientific': 'Corporate',
		'Military': 'Corporate',
		'Events/Corporate/House of Worship': 'Corporate',
		'Documentary/Video/Production/BTS': 'Documentary',
		'Editorial (Photojournalism News Gathering)': 'Editorial',
		'Fashion/Beauty': 'Fashion',
		'Action/Sports': 'Sports',
		'Portrait(Studio/Street)': 'Portrait',
		'Nature/Wildlife/Landscape/Underwater': 'Landscape',
		'TV/Broadcast/Web TV Series': 'TV/Broadcast/Web TV',
		'Blogging/Internet Video': 'Vlogging',
		'Travel/Street': 'Travel',
		'Wedding/Pre-Wedding': 'Wedding',
	},
	MEDIA_TYPES: {
		'Video': '927940000',
		'Image': '927940001'
	}
};
